export const en = {
    apply: 'Apply',
    'continue-edit': 'Continue editing',
    'creative-to-create': {
        one: '{count} creative will be created',
        some: '{count} creatives will be created',
        many: '{count} creatives will be created',
        none: '{count} creatives will be created'
    },
    'crop-again': 'Crop again',
    'default-name': 'New group',
    ok: 'OK',
    'previews-cancel': 'Cancel',
    'previews-save': 'Continue with selected sizes',
    'previews-title': 'Preview creatives',
    'show-all-previews': 'Show all'
};
